import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'

let isFileDownloadTrackingInitialized = false

export default () => {
  if (isFileDownloadTrackingInitialized) return
  isFileDownloadTrackingInitialized = true

  window.addEventListener(
    'click',
    event => {
      if (!event.isTrusted) return

      const link = event.target.closest('a')
      if (!link || !link.href) return

      const url = link.href

      if (
        url.startsWith('mailto:') ||
        url.startsWith('tel:') ||
        url.startsWith('javascript:') ||
        url.startsWith('#') ||
        link.protocol === 'mailto:' ||
        link.protocol === 'tel:'
      ) {
        return
      }

      const validExtensions = [
        'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'ppt', 'pptx', 'odt', 'ods', 'odp', 'txt', 'rtf',
        'zip', 'rar', '7z', 'tar', 'gz',
        'png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg', 'webp',
        'mp3', 'wav', 'ogg', 'flac', 'aac',
        'mp4', 'mov', 'avi', 'wmv', 'mkv', 'webm',
        'dwg', 'dxf', 'stl',
        'json', 'xml', 'yml', 'yaml', 'tsv',
        'exe', 'msi', 'apk', 'dmg', 'iso',
      ]

      const pathname = new URL(url, window.location.href).pathname
      const extension = pathname
        .split('.')
        .pop()
        .toLowerCase()

      const isDownload =
        link.hasAttribute('download') || link.dataset.download !== undefined || validExtensions.includes(extension)

      if (isDownload) {
        const fileName = pathname.split('/').pop()
        const linkText = (link.innerText || link.getAttribute('title') || fileName).trim()

        eventBus.$emit(eventDefinitions.FILE.DOWNLOAD, {
          name: fileName,
          url,
          text: linkText,
          extension,
        })
      }
    },
    true,
  )
}
